import { jwtDecode as he } from "jwt-decode";
import { createMachine as O, send as p, assign as E, interpret as b } from "xstate";
import $ from "js-cookie";
import fe from "fetch-ponyfill";
const P = "nhostRefreshToken", D = "nhostRefreshTokenId", v = "nhostRefreshTokenExpiresAt", me = 3, Ee = 60, q = 5, J = 0, ee = 1, k = 10, C = 20;
class N extends Error {
  constructor(e) {
    super(e.message), Error.captureStackTrace && Error.captureStackTrace(this, this.constructor), e instanceof Error ? (this.name = e.name, this.error = {
      error: e.name,
      status: ee,
      message: e.message
    }) : (this.name = e.error, this.error = e);
  }
}
const _ = {
  status: k,
  error: "invalid-email",
  message: "Email is incorrectly formatted"
}, ge = {
  status: k,
  error: "invalid-mfa-type",
  message: "MFA type is invalid"
}, Te = {
  status: k,
  error: "invalid-mfa-code",
  message: "MFA code is invalid"
}, H = {
  status: k,
  error: "invalid-password",
  message: "Password is incorrectly formatted"
}, F = {
  status: k,
  error: "invalid-phone-number",
  message: "Phone number is incorrectly formatted"
}, pe = {
  status: k,
  error: "invalid-mfa-ticket",
  message: "MFA ticket is invalid"
}, we = {
  status: k,
  error: "no-mfa-ticket",
  message: "No MFA ticket has been provided"
}, ye = {
  status: k,
  error: "no-refresh-token",
  message: "No refresh token has been provided"
}, ke = {
  status: C,
  error: "refresher-already-running",
  message: "The token refresher is already running. You must wait until is has finished before submitting a new token."
}, R = {
  status: C,
  error: "already-signed-in",
  message: "User is already signed in"
}, Re = {
  status: C,
  error: "unauthenticated-user",
  message: "User is not authenticated"
}, lr = {
  status: C,
  error: "user-not-anonymous",
  message: "User is not anonymous"
}, Ae = {
  status: C,
  error: "unverified-user",
  message: "Email needs verification"
}, Se = {
  status: k,
  error: "invalid-refresh-token",
  message: "Invalid or expired refresh token"
}, _e = {
  status: ee,
  error: "invalid-sign-in-method",
  message: "Invalid sign-in method"
}, L = {
  user: null,
  mfa: null,
  accessToken: {
    value: null,
    expiresAt: null,
    expiresInSeconds: 15
  },
  refreshTimer: {
    startedAt: null,
    attempts: 0,
    lastAttempt: null
  },
  refreshToken: {
    value: null
  },
  importTokenAttempts: 0,
  errors: {}
};
function Ie(n) {
  return new TextEncoder().encode(n);
}
function A(n) {
  const e = new Uint8Array(n);
  let r = "";
  for (const s of e)
    r += String.fromCharCode(s);
  return btoa(r).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
function j(n) {
  const e = n.replace(/-/g, "+").replace(/_/g, "/"), r = (4 - e.length % 4) % 4, t = e.padEnd(e.length + r, "="), s = atob(t), i = new ArrayBuffer(s.length), u = new Uint8Array(i);
  for (let m = 0; m < s.length; m++)
    u[m] = s.charCodeAt(m);
  return i;
}
function re() {
  return (window == null ? void 0 : window.PublicKeyCredential) !== void 0 && typeof window.PublicKeyCredential == "function";
}
function te(n) {
  const { id: e } = n;
  return {
    ...n,
    id: j(e),
    transports: n.transports
  };
}
function ne(n) {
  return n === "localhost" || /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/i.test(n);
}
class T extends Error {
  constructor({ message: e, code: r, cause: t, name: s }) {
    super(e, { cause: t }), this.name = s != null ? s : t.name, this.code = r;
  }
}
function ve({ error: n, options: e }) {
  var t, s;
  const { publicKey: r } = e;
  if (!r)
    throw Error("options was missing required publicKey property");
  if (n.name === "AbortError") {
    if (e.signal instanceof AbortSignal)
      return new T({
        message: "Registration ceremony was sent an abort signal",
        code: "ERROR_CEREMONY_ABORTED",
        cause: n
      });
  } else if (n.name === "ConstraintError") {
    if (((t = r.authenticatorSelection) == null ? void 0 : t.requireResidentKey) === !0)
      return new T({
        message: "Discoverable credentials were required but no available authenticator supported it",
        code: "ERROR_AUTHENTICATOR_MISSING_DISCOVERABLE_CREDENTIAL_SUPPORT",
        cause: n
      });
    if (((s = r.authenticatorSelection) == null ? void 0 : s.userVerification) === "required")
      return new T({
        message: "User verification was required but no available authenticator supported it",
        code: "ERROR_AUTHENTICATOR_MISSING_USER_VERIFICATION_SUPPORT",
        cause: n
      });
  } else {
    if (n.name === "InvalidStateError")
      return new T({
        message: "The authenticator was previously registered",
        code: "ERROR_AUTHENTICATOR_PREVIOUSLY_REGISTERED",
        cause: n
      });
    if (n.name === "NotAllowedError")
      return new T({
        message: n.message,
        code: "ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY",
        cause: n
      });
    if (n.name === "NotSupportedError")
      return r.pubKeyCredParams.filter((u) => u.type === "public-key").length === 0 ? new T({
        message: 'No entry in pubKeyCredParams was of type "public-key"',
        code: "ERROR_MALFORMED_PUBKEYCREDPARAMS",
        cause: n
      }) : new T({
        message: "No available authenticator supported any of the specified pubKeyCredParams algorithms",
        code: "ERROR_AUTHENTICATOR_NO_SUPPORTED_PUBKEYCREDPARAMS_ALG",
        cause: n
      });
    if (n.name === "SecurityError") {
      const i = window.location.hostname;
      if (ne(i)) {
        if (r.rp.id !== i)
          return new T({
            message: `The RP ID "${r.rp.id}" is invalid for this domain`,
            code: "ERROR_INVALID_RP_ID",
            cause: n
          });
      } else return new T({
        message: `${window.location.hostname} is an invalid domain`,
        code: "ERROR_INVALID_DOMAIN",
        cause: n
      });
    } else if (n.name === "TypeError") {
      if (r.user.id.byteLength < 1 || r.user.id.byteLength > 64)
        return new T({
          message: "User ID was not between 1 and 64 characters",
          code: "ERROR_INVALID_USER_ID_LENGTH",
          cause: n
        });
    } else if (n.name === "UnknownError")
      return new T({
        message: "The authenticator was unable to process the specified options, or could not create a new credential",
        code: "ERROR_AUTHENTICATOR_GENERAL_ERROR",
        cause: n
      });
  }
  return n;
}
class Oe {
  createNewAbortSignal() {
    if (this.controller) {
      const r = new Error("Cancelling existing WebAuthn API call for new one");
      r.name = "AbortError", this.controller.abort(r);
    }
    const e = new AbortController();
    return this.controller = e, e.signal;
  }
  cancelCeremony() {
    if (this.controller) {
      const e = new Error("Manually cancelling existing WebAuthn API call");
      e.name = "AbortError", this.controller.abort(e), this.controller = void 0;
    }
  }
}
const se = new Oe(), Pe = ["cross-platform", "platform"];
function ie(n) {
  if (n && !(Pe.indexOf(n) < 0))
    return n;
}
async function oe(n) {
  var c;
  if (!re())
    throw new Error("WebAuthn is not supported in this browser");
  const r = { publicKey: {
    ...n,
    challenge: j(n.challenge),
    user: {
      ...n.user,
      id: Ie(n.user.id)
    },
    excludeCredentials: (c = n.excludeCredentials) == null ? void 0 : c.map(te)
  } };
  r.signal = se.createNewAbortSignal();
  let t;
  try {
    t = await navigator.credentials.create(r);
  } catch (l) {
    throw ve({ error: l, options: r });
  }
  if (!t)
    throw new Error("Registration was not completed");
  const { id: s, rawId: i, response: u, type: m } = t;
  let d;
  typeof u.getTransports == "function" && (d = u.getTransports());
  let h;
  if (typeof u.getPublicKeyAlgorithm == "function")
    try {
      h = u.getPublicKeyAlgorithm();
    } catch (l) {
      G("getPublicKeyAlgorithm()", l);
    }
  let a;
  if (typeof u.getPublicKey == "function")
    try {
      const l = u.getPublicKey();
      l !== null && (a = A(l));
    } catch (l) {
      G("getPublicKey()", l);
    }
  let o;
  if (typeof u.getAuthenticatorData == "function")
    try {
      o = A(u.getAuthenticatorData());
    } catch (l) {
      G("getAuthenticatorData()", l);
    }
  return {
    id: s,
    rawId: A(i),
    response: {
      attestationObject: A(u.attestationObject),
      clientDataJSON: A(u.clientDataJSON),
      transports: d,
      publicKeyAlgorithm: h,
      publicKey: a,
      authenticatorData: o
    },
    type: m,
    clientExtensionResults: t.getClientExtensionResults(),
    authenticatorAttachment: ie(t.authenticatorAttachment)
  };
}
function G(n, e) {
  console.warn(`The browser extension that intercepted this WebAuthn API call incorrectly implemented ${n}. You should report this error to them.
`, e);
}
function be(n) {
  return new TextDecoder("utf-8").decode(n);
}
function Ne() {
  const n = window.PublicKeyCredential;
  return n.isConditionalMediationAvailable === void 0 ? new Promise((e) => e(!1)) : n.isConditionalMediationAvailable();
}
function Ce({ error: n, options: e }) {
  const { publicKey: r } = e;
  if (!r)
    throw Error("options was missing required publicKey property");
  if (n.name === "AbortError") {
    if (e.signal instanceof AbortSignal)
      return new T({
        message: "Authentication ceremony was sent an abort signal",
        code: "ERROR_CEREMONY_ABORTED",
        cause: n
      });
  } else {
    if (n.name === "NotAllowedError")
      return new T({
        message: n.message,
        code: "ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY",
        cause: n
      });
    if (n.name === "SecurityError") {
      const t = window.location.hostname;
      if (ne(t)) {
        if (r.rpId !== t)
          return new T({
            message: `The RP ID "${r.rpId}" is invalid for this domain`,
            code: "ERROR_INVALID_RP_ID",
            cause: n
          });
      } else return new T({
        message: `${window.location.hostname} is an invalid domain`,
        code: "ERROR_INVALID_DOMAIN",
        cause: n
      });
    } else if (n.name === "UnknownError")
      return new T({
        message: "The authenticator was unable to process the specified options, or could not create a new assertion signature",
        code: "ERROR_AUTHENTICATOR_GENERAL_ERROR",
        cause: n
      });
  }
  return n;
}
async function ae(n, e = !1) {
  var o, c;
  if (!re())
    throw new Error("WebAuthn is not supported in this browser");
  let r;
  ((o = n.allowCredentials) == null ? void 0 : o.length) !== 0 && (r = (c = n.allowCredentials) == null ? void 0 : c.map(te));
  const t = {
    ...n,
    challenge: j(n.challenge),
    allowCredentials: r
  }, s = {};
  if (e) {
    if (!await Ne())
      throw Error("Browser does not support WebAuthn autofill");
    if (document.querySelectorAll("input[autocomplete$='webauthn']").length < 1)
      throw Error('No <input> with "webauthn" as the only or last value in its `autocomplete` attribute was detected');
    s.mediation = "conditional", t.allowCredentials = [];
  }
  s.publicKey = t, s.signal = se.createNewAbortSignal();
  let i;
  try {
    i = await navigator.credentials.get(s);
  } catch (l) {
    throw Ce({ error: l, options: s });
  }
  if (!i)
    throw new Error("Authentication was not completed");
  const { id: u, rawId: m, response: d, type: h } = i;
  let a;
  return d.userHandle && (a = be(d.userHandle)), {
    id: u,
    rawId: A(m),
    response: {
      authenticatorData: A(d.authenticatorData),
      clientDataJSON: A(d.clientDataJSON),
      signature: A(d.signature),
      userHandle: a
    },
    type: h,
    clientExtensionResults: i.getClientExtensionResults(),
    authenticatorAttachment: ie(i.authenticatorAttachment)
  };
}
const V = typeof window != "undefined", M = /* @__PURE__ */ new Map(), De = (n) => {
  var e;
  return V && typeof localStorage != "undefined" ? localStorage.getItem(n) : (e = M.get(n)) != null ? e : null;
}, xe = (n, e) => {
  V && typeof localStorage != "undefined" ? e ? localStorage.setItem(n, e) : localStorage.removeItem(n) : e ? M.set(n, e) : M.has(n) && M.delete(n);
}, Ue = (n, e) => {
  if (n === "localStorage" || n === "web")
    return De;
  if (n === "cookie")
    return (r) => {
      var t;
      return V && (t = $.get(r)) != null ? t : null;
    };
  if (!e)
    throw Error(
      `clientStorageType is set to '${n}' but no clientStorage has been given`
    );
  if (n === "react-native")
    return (r) => {
      var t;
      return (t = e.getItem) == null ? void 0 : t.call(e, r);
    };
  if (n === "capacitor")
    return (r) => {
      var t;
      return (t = e.get) == null ? void 0 : t.call(e, { key: r });
    };
  if (n === "expo-secure-storage")
    return (r) => {
      var t;
      return (t = e.getItemAsync) == null ? void 0 : t.call(e, r);
    };
  if (n === "custom") {
    if (e.getItem && e.removeItem)
      return e.getItem;
    if (e.getItemAsync)
      return e.getItemAsync;
    throw Error(
      `clientStorageType is set to 'custom' but clientStorage is missing either "getItem" and "removeItem" properties or "getItemAsync" property`
    );
  }
  throw Error(`Unknown storage type: ${n}`);
}, Me = (n, e) => {
  if (n === "localStorage" || n === "web")
    return xe;
  if (n === "cookie")
    return (r, t) => {
      V && (t ? $.set(r, t, { expires: 30, sameSite: "lax", httpOnly: !1 }) : $.remove(r));
    };
  if (!e)
    throw Error(
      `clientStorageType is set to '${n}' but no clienStorage has been given`
    );
  if (n === "react-native")
    return (r, t) => {
      var s, i;
      return t ? (s = e.setItem) == null ? void 0 : s.call(e, r, t) : (i = e.removeItem) == null ? void 0 : i.call(e, r);
    };
  if (n === "capacitor")
    return (r, t) => {
      var s, i;
      return t ? (s = e.set) == null ? void 0 : s.call(e, { key: r, value: t }) : (i = e.remove) == null ? void 0 : i.call(e, { key: r });
    };
  if (n === "expo-secure-storage")
    return async (r, t) => {
      var s, i;
      return t ? (s = e.setItemAsync) == null ? void 0 : s.call(e, r, t) : (i = e.deleteItemAsync) == null ? void 0 : i.call(e, r);
    };
  if (n === "custom") {
    if (!e.removeItem)
      throw Error(
        "clientStorageType is set to 'custom' but clientStorage is missing a removeItem property"
      );
    if (e.setItem)
      return (r, t) => {
        var s, i;
        return t ? (s = e.setItem) == null ? void 0 : s.call(e, r, t) : (i = e.removeItem) == null ? void 0 : i.call(e, r);
      };
    if (e.setItemAsync)
      return async (r, t) => {
        var s, i;
        return t ? (s = e.setItemAsync) == null ? void 0 : s.call(e, r, t) : (i = e.removeItem) == null ? void 0 : i.call(e, r);
      };
    throw Error(
      "clientStorageType is set to 'custom' but clientStorage is missing setItem or setItemAsync property"
    );
  }
  throw Error(`Unknown storage type: ${n}`);
}, x = (n) => !n || !n.accessToken.value || !n.accessToken.expiresAt || !n.user ? null : {
  accessToken: n.accessToken.value,
  accessTokenExpiresIn: (n.accessToken.expiresAt.getTime() - Date.now()) / 1e3,
  refreshToken: n.refreshToken.value,
  user: n.user
}, S = ({
  accessToken: n,
  refreshToken: e,
  isError: r,
  user: t,
  error: s
}) => r ? {
  session: null,
  error: s
} : t && n ? {
  // TODO either return the refresh token or remove it from the session type
  session: { accessToken: n, accessTokenExpiresIn: 0, refreshToken: e, user: t },
  error: null
} : { session: null, error: null }, K = () => typeof window != "undefined" && typeof window.location != "undefined";
let ce = globalThis.fetch;
typeof EdgeRuntime != "string" && (ce = fe().fetch);
const ue = async (n, e, {
  token: r,
  body: t,
  extraHeaders: s
} = {}) => {
  const i = {
    "Content-Type": "application/json",
    Accept: "*/*"
  };
  r && (i.Authorization = `Bearer ${r}`);
  const u = { ...i, ...s }, m = {
    method: e,
    headers: u
  };
  t && (m.body = JSON.stringify(t));
  try {
    const d = await ce(n, m);
    if (!d.ok) {
      const h = await d.json();
      return Promise.reject({ error: h });
    }
    try {
      return { data: await d.json(), error: null };
    } catch {
      return console.warn(`Unexpected response: can't parse the response of the server at ${n}`), { data: "OK", error: null };
    }
  } catch {
    const h = {
      message: "Network Error",
      status: J,
      error: "network"
    };
    return Promise.reject({ error: h });
  }
}, y = async (n, e, r, t) => ue(n, "POST", { token: r, body: e, extraHeaders: t }), Ke = (n, e) => ue(n, "GET", { token: e }), W = (n, e) => {
  const r = e && Object.entries(e).map(([t, s]) => {
    const i = Array.isArray(s) ? s.join(",") : typeof s == "object" ? JSON.stringify(s) : s;
    return `${t}=${encodeURIComponent(i)}`;
  }).join("&");
  return r ? `${n}?${r}` : n;
}, w = (n, e) => {
  if (!(e != null && e.redirectTo))
    return e;
  const { redirectTo: r, ...t } = e;
  if (!n)
    return r.startsWith("/") ? t : e;
  const s = new URL(n), i = Object.fromEntries(new URLSearchParams(s.search)), u = new URL(r.startsWith("/") ? s.origin + r : r), m = new URLSearchParams(u.search);
  let d = Object.fromEntries(m);
  r.startsWith("/") && (d = { ...i, ...d });
  let h = s.pathname;
  return u.pathname.length > 1 && (h += u.pathname.slice(1)), {
    ...t,
    redirectTo: W(u.origin + h, d)
  };
};
function U(n, e) {
  var s;
  if (!e) {
    if (typeof window == "undefined")
      return;
    e = ((s = window.location) == null ? void 0 : s.href) || "";
  }
  n = n.replace(/[\[\]]/g, "\\$&");
  const r = new RegExp("[?&#]" + n + "(=([^&#]*)|&|#|$)"), t = r.exec(e);
  return t ? t[2] ? decodeURIComponent(t[2].replace(/\+/g, " ")) : "" : null;
}
function B(n) {
  var r;
  if (typeof window == "undefined")
    return;
  const e = window == null ? void 0 : window.location;
  if (e && e) {
    const t = new URLSearchParams(e.search), s = new URLSearchParams((r = e.hash) == null ? void 0 : r.slice(1));
    t.delete(n), s.delete(n);
    let i = window.location.pathname;
    Array.from(t).length && (i += `?${t.toString()}`), Array.from(s).length && (i += `#${s.toString()}`), window.history.pushState({}, "", i);
  }
}
const I = (n) => !!n && typeof n == "string" && !!String(n).toLowerCase().match(
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
), Y = (n) => !!n && typeof n == "string" && n.length >= me, z = (n) => !!n && typeof n == "string", Ve = (n) => n && typeof n == "string" && n.match(/^mfaTotp:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i), Le = ({
  backendUrl: n,
  clientUrl: e,
  clientStorageType: r = "web",
  clientStorage: t,
  refreshIntervalTime: s,
  autoRefreshToken: i = !0,
  autoSignIn: u = !0
}) => {
  const m = Ue(r, t), d = Me(r, t), h = async (a, o, c, l) => (await y(`${n}${a}`, o, c, l)).data;
  return O(
    {
      schema: {
        context: {},
        events: {},
        services: {}
      },
      tsTypes: {},
      context: L,
      predictableActionArguments: !0,
      id: "nhost",
      type: "parallel",
      states: {
        authentication: {
          initial: "starting",
          on: {
            SESSION_UPDATE: [
              {
                cond: "hasSession",
                actions: ["saveSession", "resetTimer", "reportTokenChanged"],
                target: ".signedIn"
              }
            ]
          },
          states: {
            starting: {
              tags: ["loading"],
              always: { cond: "isSignedIn", target: "signedIn" },
              invoke: {
                id: "importRefreshToken",
                src: "importRefreshToken",
                onDone: [
                  {
                    cond: "hasSession",
                    actions: ["saveSession", "reportTokenChanged"],
                    target: "signedIn"
                  },
                  {
                    target: "signedOut"
                  }
                ],
                onError: [
                  {
                    cond: "shouldRetryImportToken",
                    actions: "incrementTokenImportAttempts",
                    target: "retryTokenImport"
                  },
                  { actions: ["saveAuthenticationError"], target: "signedOut" }
                ]
              }
            },
            retryTokenImport: {
              tags: ["loading"],
              after: {
                RETRY_IMPORT_TOKEN_DELAY: "starting"
              }
            },
            signedOut: {
              initial: "noErrors",
              entry: "reportSignedOut",
              states: {
                noErrors: {},
                success: {},
                needsSmsOtp: {},
                needsMfa: {},
                failed: {},
                signingOut: {
                  entry: ["clearContextExceptTokens"],
                  exit: ["destroyAccessToken", "destroyRefreshToken", "reportTokenChanged"],
                  invoke: {
                    src: "signout",
                    id: "signingOut",
                    onDone: {
                      target: "success"
                    },
                    onError: {
                      target: "failed",
                      actions: ["saveAuthenticationError"]
                    }
                  }
                }
              },
              on: {
                SIGNIN_PASSWORD: "authenticating.password",
                SIGNIN_ANONYMOUS: "authenticating.anonymous",
                SIGNIN_SECURITY_KEY_EMAIL: "authenticating.securityKeyEmail",
                SIGNIN_MFA_TOTP: "authenticating.mfa.totp",
                SIGNIN_PAT: "authenticating.pat"
              }
            },
            authenticating: {
              entry: "resetErrors",
              states: {
                password: {
                  invoke: {
                    src: "signInPassword",
                    id: "authenticateUserWithPassword",
                    onDone: [
                      {
                        cond: "hasMfaTicket",
                        actions: ["saveMfaTicket"],
                        target: "#nhost.authentication.signedOut.needsMfa"
                      },
                      {
                        actions: ["saveSession", "reportTokenChanged"],
                        target: "#nhost.authentication.signedIn"
                      }
                    ],
                    onError: [
                      {
                        cond: "unverified",
                        target: [
                          "#nhost.authentication.signedOut",
                          "#nhost.registration.incomplete.needsEmailVerification"
                        ]
                      },
                      {
                        actions: "saveAuthenticationError",
                        target: "#nhost.authentication.signedOut.failed"
                      }
                    ]
                  }
                },
                pat: {
                  invoke: {
                    src: "signInPAT",
                    id: "authenticateWithPAT",
                    onDone: {
                      actions: ["savePATSession", "reportTokenChanged"],
                      target: "#nhost.authentication.signedIn"
                    },
                    onError: {
                      actions: "saveAuthenticationError",
                      target: "#nhost.authentication.signedOut.failed"
                    }
                  }
                },
                anonymous: {
                  invoke: {
                    src: "signInAnonymous",
                    id: "authenticateAnonymously",
                    onDone: {
                      actions: ["saveSession", "reportTokenChanged"],
                      target: "#nhost.authentication.signedIn"
                    },
                    onError: {
                      actions: "saveAuthenticationError",
                      target: "#nhost.authentication.signedOut.failed"
                    }
                  }
                },
                mfa: {
                  states: {
                    totp: {
                      invoke: {
                        src: "signInMfaTotp",
                        id: "signInMfaTotp",
                        onDone: {
                          actions: ["saveSession", "reportTokenChanged"],
                          target: "#nhost.authentication.signedIn"
                        },
                        onError: {
                          actions: ["saveAuthenticationError"],
                          target: "#nhost.authentication.signedOut.failed"
                        }
                      }
                    }
                  }
                },
                securityKeyEmail: {
                  invoke: {
                    src: "signInSecurityKeyEmail",
                    id: "authenticateUserWithSecurityKey",
                    onDone: {
                      actions: ["saveSession", "reportTokenChanged"],
                      target: "#nhost.authentication.signedIn"
                    },
                    onError: [
                      {
                        cond: "unverified",
                        target: [
                          "#nhost.authentication.signedOut",
                          "#nhost.registration.incomplete.needsEmailVerification"
                        ]
                      },
                      {
                        actions: "saveAuthenticationError",
                        target: "#nhost.authentication.signedOut.failed"
                      }
                    ]
                  }
                }
              }
            },
            signedIn: {
              type: "parallel",
              entry: ["reportSignedIn", "cleanUrl", "broadcastToken", "resetErrors"],
              on: {
                SIGNOUT: "signedOut.signingOut"
              },
              states: {
                refreshTimer: {
                  id: "timer",
                  initial: "idle",
                  states: {
                    disabled: { type: "final" },
                    stopped: {
                      always: {
                        cond: "noToken",
                        target: "idle"
                      }
                    },
                    idle: {
                      always: [
                        { cond: "isAutoRefreshDisabled", target: "disabled" },
                        { cond: "isRefreshTokenPAT", target: "disabled" },
                        { cond: "hasRefreshToken", target: "running" }
                      ]
                    },
                    running: {
                      initial: "pending",
                      entry: "resetTimer",
                      states: {
                        pending: {
                          after: {
                            1e3: {
                              internal: !1,
                              target: "pending"
                            }
                          },
                          always: {
                            cond: "refreshTimerShouldRefresh",
                            target: "refreshing"
                          }
                        },
                        refreshing: {
                          invoke: {
                            src: "refreshToken",
                            id: "refreshToken",
                            onDone: {
                              actions: ["saveSession", "resetTimer", "reportTokenChanged"],
                              target: "pending"
                            },
                            onError: [
                              {
                                cond: "isUnauthorizedError",
                                target: "#nhost.authentication.signedOut"
                              },
                              { actions: "saveRefreshAttempt", target: "pending" }
                            ]
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        },
        token: {
          initial: "idle",
          states: {
            idle: {
              on: {
                TRY_TOKEN: "running"
              },
              initial: "noErrors",
              states: { noErrors: {}, error: {} }
            },
            running: {
              invoke: {
                src: "refreshToken",
                id: "authenticateWithToken",
                onDone: {
                  actions: ["saveSession", "reportTokenChanged"],
                  target: ["#nhost.authentication.signedIn", "idle.noErrors"]
                },
                onError: [
                  { cond: "isSignedIn", target: "idle.error" },
                  {
                    actions: "saveAuthenticationError",
                    target: ["#nhost.authentication.signedOut.failed", "idle.error"]
                  }
                ]
              }
            }
          }
        },
        registration: {
          initial: "incomplete",
          on: {
            SIGNED_IN: [{ cond: "isAnonymous", target: ".incomplete" }, ".complete"]
          },
          states: {
            incomplete: {
              on: {
                SIGNUP_EMAIL_PASSWORD: "emailPassword",
                SIGNUP_SECURITY_KEY: "securityKey",
                PASSWORDLESS_EMAIL: "passwordlessEmail",
                PASSWORDLESS_SMS: "passwordlessSms",
                PASSWORDLESS_SMS_OTP: "passwordlessSmsOtp"
              },
              initial: "noErrors",
              states: {
                noErrors: {},
                needsEmailVerification: {},
                needsOtp: {},
                failed: {}
              }
            },
            emailPassword: {
              entry: ["resetErrors"],
              invoke: {
                src: "signUpEmailPassword",
                id: "signUpEmailPassword",
                onDone: [
                  {
                    cond: "hasSession",
                    actions: ["saveSession", "reportTokenChanged"],
                    target: "#nhost.authentication.signedIn"
                  },
                  {
                    actions: "clearContext",
                    target: ["#nhost.authentication.signedOut", "incomplete.needsEmailVerification"]
                  }
                ],
                onError: [
                  {
                    cond: "unverified",
                    target: "incomplete.needsEmailVerification"
                  },
                  {
                    actions: "saveRegistrationError",
                    target: "incomplete.failed"
                  }
                ]
              }
            },
            securityKey: {
              entry: ["resetErrors"],
              invoke: {
                src: "signUpSecurityKey",
                id: "signUpSecurityKey",
                onDone: [
                  {
                    cond: "hasSession",
                    actions: ["saveSession", "reportTokenChanged"],
                    target: "#nhost.authentication.signedIn"
                  },
                  {
                    actions: "clearContext",
                    target: ["#nhost.authentication.signedOut", "incomplete.needsEmailVerification"]
                  }
                ],
                onError: [
                  {
                    cond: "unverified",
                    target: "incomplete.needsEmailVerification"
                  },
                  {
                    actions: "saveRegistrationError",
                    target: "incomplete.failed"
                  }
                ]
              }
            },
            passwordlessEmail: {
              entry: ["resetErrors"],
              invoke: {
                src: "passwordlessEmail",
                id: "passwordlessEmail",
                onDone: {
                  actions: "clearContext",
                  target: ["#nhost.authentication.signedOut", "incomplete.needsEmailVerification"]
                },
                onError: {
                  actions: "saveRegistrationError",
                  target: "incomplete.failed"
                }
              }
            },
            passwordlessSms: {
              entry: ["resetErrors"],
              invoke: {
                src: "passwordlessSms",
                id: "passwordlessSms",
                onDone: {
                  actions: "clearContext",
                  target: ["#nhost.authentication.signedOut", "incomplete.needsOtp"]
                },
                onError: {
                  actions: "saveRegistrationError",
                  target: "incomplete.failed"
                }
              }
            },
            passwordlessSmsOtp: {
              entry: ["resetErrors"],
              invoke: {
                src: "passwordlessSmsOtp",
                id: "passwordlessSmsOtp",
                onDone: {
                  actions: ["saveSession", "reportTokenChanged"],
                  target: "#nhost.authentication.signedIn"
                },
                onError: {
                  actions: "saveRegistrationError",
                  target: "incomplete.failed"
                }
              }
            },
            complete: {
              on: {
                SIGNED_OUT: "incomplete"
              }
            }
          }
        }
      }
    },
    {
      actions: {
        reportSignedIn: p("SIGNED_IN"),
        reportSignedOut: p("SIGNED_OUT"),
        reportTokenChanged: p("TOKEN_CHANGED"),
        incrementTokenImportAttempts: E({
          importTokenAttempts: ({ importTokenAttempts: a }) => a + 1
        }),
        clearContext: E(() => (d(v, null), d(P, null), d(D, null), {
          ...L
        })),
        clearContextExceptTokens: E(({ accessToken: a, refreshToken: o }) => ({
          ...L,
          accessToken: a,
          refreshToken: o
        })),
        // * Save session in the context, and persist the refresh token and the jwt expiration outside of the machine
        saveSession: E({
          user: (a, { data: o }) => {
            var c;
            return ((c = o == null ? void 0 : o.session) == null ? void 0 : c.user) || null;
          },
          accessToken: (a, { data: o }) => {
            if (o.session) {
              const { accessTokenExpiresIn: c, accessToken: l } = o.session, f = new Date(Date.now() + c * 1e3);
              return d(v, f.toISOString()), {
                value: l,
                expiresAt: f,
                expiresInSeconds: c
              };
            }
            return d(v, null), {
              value: null,
              expiresAt: null,
              expiresInSeconds: null
            };
          },
          refreshToken: (a, { data: o }) => {
            var f, g;
            const c = ((f = o.session) == null ? void 0 : f.refreshToken) || null, l = ((g = o.session) == null ? void 0 : g.refreshTokenId) || null;
            return c && d(P, c), l && d(D, l), { value: c };
          }
        }),
        savePATSession: E({
          user: (a, { data: o }) => {
            var c;
            return ((c = o == null ? void 0 : o.session) == null ? void 0 : c.user) || null;
          },
          accessToken: (a, { data: o }) => {
            if (o.session) {
              const { accessTokenExpiresIn: c, accessToken: l } = o.session, f = new Date(Date.now() + c * 1e3);
              return d(v, f.toISOString()), {
                value: l,
                expiresAt: f,
                expiresInSeconds: c
              };
            }
            return d(v, null), {
              value: null,
              expiresAt: null,
              expiresInSeconds: null
            };
          },
          refreshToken: (a, { data: o }) => {
            var f, g;
            const c = ((f = o.session) == null ? void 0 : f.refreshToken) || null, l = ((g = o.session) == null ? void 0 : g.refreshTokenId) || null;
            return c && d(P, c), l && d(D, l), { value: c, isPAT: !0 };
          }
        }),
        saveMfaTicket: E({
          mfa: (a, o) => {
            var c;
            return (c = o.data) == null ? void 0 : c.mfa;
          }
        }),
        resetTimer: E({
          refreshTimer: (a) => ({
            startedAt: /* @__PURE__ */ new Date(),
            attempts: 0,
            lastAttempt: null
          })
        }),
        saveRefreshAttempt: E({
          refreshTimer: (a, o) => ({
            startedAt: a.refreshTimer.startedAt,
            attempts: a.refreshTimer.attempts + 1,
            lastAttempt: /* @__PURE__ */ new Date()
          })
        }),
        // * Authentication errors
        saveAuthenticationError: E({
          // * Untyped action payload. See https://github.com/statelyai/xstate/issues/3037
          errors: ({ errors: a }, { data: { error: o } }) => ({
            ...a,
            authentication: o
          })
        }),
        resetErrors: E({
          errors: (a) => ({}),
          importTokenAttempts: (a) => 0
        }),
        saveRegistrationError: E({
          // * Untyped action payload. See https://github.com/statelyai/xstate/issues/3037
          errors: ({ errors: a }, { data: { error: o } }) => ({ ...a, registration: o })
        }),
        destroyRefreshToken: E({
          refreshToken: (a) => (d(P, null), d(D, null), { value: null })
        }),
        destroyAccessToken: E({
          accessToken: (a) => (d(v, null), {
            value: null,
            expiresAt: null,
            expiresInSeconds: null
          })
        }),
        // * Clean the browser url when `autoSignIn` is activated
        cleanUrl: () => {
          u && U("refreshToken") && (B("refreshToken"), B("type"));
        },
        // * Broadcast the token to other tabs when `autoSignIn` is activated
        broadcastToken: (a) => {
          if (u)
            try {
              new BroadcastChannel("nhost").postMessage({
                type: "broadcast_token",
                payload: {
                  token: a.refreshToken.value
                }
              });
            } catch {
            }
        }
      },
      guards: {
        isAnonymous: (a, o) => {
          var c;
          return !!((c = a.user) != null && c.isAnonymous);
        },
        isSignedIn: (a) => !!a.user && !!a.accessToken.value,
        noToken: (a) => !a.refreshToken.value,
        isRefreshTokenPAT: (a) => {
          var o;
          return !!((o = a.refreshToken) != null && o.isPAT);
        },
        hasRefreshToken: (a) => !!a.refreshToken.value,
        isAutoRefreshDisabled: () => !i,
        refreshTimerShouldRefresh: (a) => {
          const { expiresAt: o } = a.accessToken;
          if (!o)
            return !1;
          if (a.refreshTimer.lastAttempt)
            return a.refreshTimer.attempts > q ? !1 : Date.now() - a.refreshTimer.lastAttempt.getTime() > Math.pow(2, a.refreshTimer.attempts - 1) * 5e3;
          if (o.getTime() < Date.now() || s && Date.now() - a.refreshTimer.startedAt.getTime() > s * 1e3)
            return !0;
          const c = a.accessToken.expiresInSeconds;
          return c ? o.getTime() - Date.now() - 1e3 * Math.min(Ee, c * 0.5) <= 0 : !1;
        },
        // * Untyped action payload. See https://github.com/statelyai/xstate/issues/3037
        /** Shoud retry to import the token on network error or any internal server error.
         * Don't retry more than REFRESH_TOKEN_MAX_ATTEMPTS times.
         */
        shouldRetryImportToken: (a, o) => a.importTokenAttempts < q && (o.data.error.status === J || o.data.error.status >= 500),
        // * Authentication errors
        // * Untyped action payload. See https://github.com/statelyai/xstate/issues/3037
        unverified: (a, { data: { error: o } }) => o.status === 401 && // * legacy: don't use the message contents to determine if the email is unverified, but the error type (error.error)
        (o.message === "Email is not verified" || o.error === "unverified-user"),
        // * Event guards
        hasSession: (a, o) => {
          var c;
          return !!((c = o.data) != null && c.session);
        },
        hasMfaTicket: (a, o) => {
          var c;
          return !!((c = o.data) != null && c.mfa);
        },
        isUnauthorizedError: (a, { data: { error: o } }) => o.status === 401
      },
      services: {
        signInPassword: (a, { email: o, password: c }) => I(o) ? Y(c) ? h("/signin/email-password", {
          email: o,
          password: c
        }) : Promise.reject({ error: H }) : Promise.reject({ error: _ }),
        signInPAT: (a, { pat: o }) => h("/signin/pat", {
          personalAccessToken: o
        }),
        passwordlessSms: (a, { phoneNumber: o, options: c }) => {
          var l;
          return z(o) ? (l = a.user) != null && l.isAnonymous ? (console.warn(
            "Deanonymisation from a phone number is not yet implemented in hasura-auth"
          ), h(
            "/user/deanonymize",
            {
              signInMethod: "passwordless",
              connection: "sms",
              phoneNumber: o,
              options: w(e, c)
            },
            a.accessToken.value
          )) : h("/signin/passwordless/sms", {
            phoneNumber: o,
            options: w(e, c)
          }) : Promise.reject({ error: F });
        },
        passwordlessSmsOtp: (a, { phoneNumber: o, otp: c }) => z(o) ? h("/signin/passwordless/sms/otp", {
          phoneNumber: o,
          otp: c
        }) : Promise.reject({ error: F }),
        passwordlessEmail: (a, { email: o, options: c }) => {
          var l;
          return I(o) ? (l = a.user) != null && l.isAnonymous ? h(
            "/user/deanonymize",
            {
              signInMethod: "passwordless",
              connection: "email",
              email: o,
              options: w(e, c)
            },
            a.accessToken.value
          ) : h("/signin/passwordless/email", {
            email: o,
            options: w(e, c)
          }) : Promise.reject({ error: _ });
        },
        signInAnonymous: (a) => h("/signin/anonymous"),
        signInMfaTotp: (a, o) => {
          var l;
          const c = o.ticket || ((l = a.mfa) == null ? void 0 : l.ticket);
          return c ? Ve(c) ? h("/signin/mfa/totp", {
            ticket: c,
            otp: o.otp
          }) : Promise.reject({ error: pe }) : Promise.reject({ error: we });
        },
        signInSecurityKeyEmail: async (a, { email: o }) => {
          if (!I(o))
            throw new N(_);
          const c = await h(
            "/signin/webauthn",
            { email: o }
          );
          let l;
          try {
            l = await ae(c);
          } catch (f) {
            throw new N(f);
          }
          return h("/signin/webauthn/verify", { email: o, credential: l });
        },
        refreshToken: async (a, o) => {
          const c = o.type === "TRY_TOKEN" ? o.token : a.refreshToken.value;
          return { session: await h("/token", {
            refreshToken: c
          }), error: null };
        },
        signout: async (a, o) => {
          const c = await h(
            "/signout",
            {
              refreshToken: a.refreshToken.value,
              all: !!o.all
            },
            o.all ? a.accessToken.value : void 0
          );
          try {
            new BroadcastChannel("nhost").postMessage({ type: "signout" });
          } catch {
          }
          return c;
        },
        signUpEmailPassword: async (a, { email: o, password: c, options: l, requestOptions: f }) => {
          var g;
          return I(o) ? Y(c) ? (g = a.user) != null && g.isAnonymous ? h(
            "/user/deanonymize",
            {
              signInMethod: "email-password",
              email: o,
              password: c,
              options: w(e, l)
            },
            a.accessToken.value,
            f == null ? void 0 : f.headers
          ) : h(
            "/signup/email-password",
            {
              email: o,
              password: c,
              options: w(e, l)
            },
            null,
            f == null ? void 0 : f.headers
          ) : Promise.reject({ error: H }) : Promise.reject({ error: _ });
        },
        signUpSecurityKey: async (a, { email: o, options: c }) => {
          if (!I(o))
            return Promise.reject({ error: _ });
          const l = c == null ? void 0 : c.nickname;
          l && delete c.nickname;
          const f = await h(
            "/signup/webauthn",
            { email: o, options: c }
          );
          let g;
          try {
            g = await oe(f);
          } catch (de) {
            throw new N(de);
          }
          return h("/signup/webauthn/verify", {
            credential: g,
            options: {
              redirectTo: c == null ? void 0 : c.redirectTo,
              nickname: l
            }
          });
        },
        importRefreshToken: async (a) => {
          if (a.user && a.refreshToken.value && a.accessToken.value && a.accessToken.expiresAt)
            return {
              session: {
                accessToken: a.accessToken.value,
                accessTokenExpiresIn: a.accessToken.expiresAt.getTime() - Date.now(),
                refreshToken: a.refreshToken.value,
                user: a.user
              },
              error: null
            };
          let o = null;
          if (u) {
            const l = U("refreshToken") || null;
            if (l)
              try {
                return { session: await h("/token", {
                  refreshToken: l
                }), error: null };
              } catch (f) {
                o = f.error;
              }
            else {
              const f = U("error"), g = U("errorDescription");
              if (f && g !== "social user already exists")
                return Promise.reject({
                  session: null,
                  error: {
                    status: k,
                    error: f,
                    message: g || f
                  }
                });
            }
          }
          const c = await m(P);
          if (c)
            try {
              return { session: await h("/token", {
                refreshToken: c
              }), error: null };
            } catch (l) {
              o = l.error;
            }
          return o ? Promise.reject({ error: o, session: null }) : { error: null, session: null };
        }
      },
      delays: {
        RETRY_IMPORT_TOKEN_DELAY: ({ importTokenAttempts: a }) => Math.pow(2, a - 1) * 5e3
      }
    }
  );
}, Ge = ({ backendUrl: n, clientUrl: e, interpreter: r }) => O(
  {
    schema: {
      context: {},
      events: {},
      services: {}
    },
    tsTypes: {},
    predictableActionArguments: !0,
    id: "changeEmail",
    initial: "idle",
    context: { error: null },
    states: {
      idle: {
        on: {
          REQUEST: [
            {
              cond: "invalidEmail",
              actions: "saveInvalidEmailError",
              target: ".error"
            },
            {
              target: "requesting"
            }
          ]
        },
        initial: "initial",
        states: {
          initial: {},
          success: {},
          error: {}
        }
      },
      requesting: {
        invoke: {
          src: "requestChange",
          id: "requestChange",
          onDone: { target: "idle.success", actions: "reportSuccess" },
          onError: { actions: ["saveRequestError", "reportError"], target: "idle.error" }
        }
      }
    }
  },
  {
    actions: {
      saveInvalidEmailError: E({ error: (t) => _ }),
      saveRequestError: E({
        // * Untyped action payload. See https://github.com/statelyai/xstate/issues/3037
        error: (t, { data: { error: s } }) => s
      }),
      reportError: p((t) => ({ type: "ERROR", error: t.error })),
      // TODO change email in the main machine (context.user.email)
      reportSuccess: p("SUCCESS")
    },
    guards: {
      invalidEmail: (t, { email: s }) => !I(s)
    },
    services: {
      requestChange: async (t, { email: s, options: i }) => (await y(
        `${n}/user/email/change`,
        { newEmail: s, options: w(e, i) },
        r == null ? void 0 : r.getSnapshot().context.accessToken.value
      )).data
    }
  }
), $e = ({ backendUrl: n, interpreter: e }) => O(
  {
    schema: {
      context: {},
      events: {},
      services: {}
    },
    tsTypes: {},
    predictableActionArguments: !0,
    id: "changePassword",
    initial: "idle",
    context: { error: null },
    states: {
      idle: {
        on: {
          REQUEST: [
            {
              cond: "invalidPassword",
              actions: "saveInvalidPasswordError",
              target: ".error"
            },
            {
              target: "requesting"
            }
          ]
        },
        initial: "initial",
        states: {
          initial: {},
          success: {},
          error: {}
        }
      },
      requesting: {
        invoke: {
          src: "requestChange",
          id: "requestChange",
          onDone: { target: "idle.success", actions: "reportSuccess" },
          onError: { actions: ["saveRequestError", "reportError"], target: "idle.error" }
        }
      }
    }
  },
  {
    actions: {
      saveInvalidPasswordError: E({ error: (r) => H }),
      saveRequestError: E({
        // * Untyped action payload. See https://github.com/statelyai/xstate/issues/3037
        error: (r, { data: { error: t } }) => t
      }),
      reportError: p((r) => ({ type: "ERROR", error: r.error })),
      reportSuccess: p("SUCCESS")
    },
    guards: {
      invalidPassword: (r, { password: t }) => !Y(t)
    },
    services: {
      requestChange: (r, { password: t, ticket: s }) => y(
        `${n}/user/password`,
        { newPassword: t, ticket: s },
        e == null ? void 0 : e.getSnapshot().context.accessToken.value
      )
    }
  }
), dr = ({ backendUrl: n, interpreter: e }) => O(
  {
    schema: {
      context: {},
      events: {}
    },
    tsTypes: {},
    predictableActionArguments: !0,
    id: "enableMfa",
    initial: "idle",
    context: { error: null, imageUrl: null, secret: null },
    states: {
      idle: {
        initial: "initial",
        on: {
          GENERATE: "generating"
        },
        states: {
          initial: {},
          error: {}
        }
      },
      generating: {
        invoke: {
          src: "generate",
          id: "generate",
          onDone: { target: "generated", actions: ["reportGeneratedSuccess", "saveGeneration"] },
          onError: { actions: ["saveError", "reportGeneratedError"], target: "idle.error" }
        }
      },
      generated: {
        initial: "idle",
        states: {
          idle: {
            initial: "idle",
            on: {
              ACTIVATE: [
                {
                  cond: "invalidMfaType",
                  actions: "saveInvalidMfaTypeError",
                  target: ".error"
                },
                {
                  cond: "invalidMfaCode",
                  actions: "saveInvalidMfaCodeError",
                  target: ".error"
                },
                {
                  target: "activating"
                }
              ]
            },
            states: { idle: {}, error: {} }
          },
          activating: {
            invoke: {
              src: "activate",
              id: "activate",
              onDone: { target: "activated", actions: "reportSuccess" },
              onError: { actions: ["saveError", "reportError"], target: "idle.error" }
            }
          },
          activated: { type: "final" }
        }
      }
    }
  },
  {
    actions: {
      saveInvalidMfaTypeError: E({ error: (r) => ge }),
      saveInvalidMfaCodeError: E({ error: (r) => Te }),
      saveError: E({
        error: (r, { data: { error: t } }) => t
      }),
      saveGeneration: E({
        imageUrl: (r, { data: { imageUrl: t } }) => t,
        secret: (r, { data: { totpSecret: t } }) => t
      }),
      reportError: p((r, t) => (console.log("REPORT", r, t), { type: "ERROR", error: r.error })),
      reportSuccess: p("SUCCESS"),
      reportGeneratedSuccess: p("GENERATED"),
      reportGeneratedError: p((r) => ({ type: "GENERATED_ERROR", error: r.error }))
    },
    guards: {
      invalidMfaCode: (r, { code: t }) => !t,
      invalidMfaType: (r, { activeMfaType: t }) => !t || t !== "totp"
    },
    services: {
      generate: async (r) => {
        const { data: t } = await Ke(
          `${n}/mfa/totp/generate`,
          e == null ? void 0 : e.getSnapshot().context.accessToken.value
        );
        return t;
      },
      activate: (r, { code: t, activeMfaType: s }) => y(
        `${n}/user/mfa`,
        { code: t, activeMfaType: s },
        e == null ? void 0 : e.getSnapshot().context.accessToken.value
      )
    }
  }
), He = ({ backendUrl: n, clientUrl: e }) => O(
  {
    schema: {
      context: {},
      events: {},
      services: {}
    },
    tsTypes: {},
    predictableActionArguments: !0,
    id: "changePassword",
    initial: "idle",
    context: { error: null },
    states: {
      idle: {
        on: {
          REQUEST: [
            {
              cond: "invalidEmail",
              actions: "saveInvalidEmailError",
              target: ".error"
            },
            {
              target: "requesting"
            }
          ]
        },
        initial: "initial",
        states: {
          initial: {},
          success: {},
          error: {}
        }
      },
      requesting: {
        invoke: {
          src: "requestChange",
          id: "requestChange",
          onDone: { target: "idle.success", actions: "reportSuccess" },
          onError: { actions: ["saveRequestError", "reportError"], target: "idle.error" }
        }
      }
    }
  },
  {
    actions: {
      saveInvalidEmailError: E({ error: (r) => _ }),
      saveRequestError: E({
        // * Untyped action payload. See https://github.com/statelyai/xstate/issues/3037
        error: (r, { data: { error: t } }) => t
      }),
      reportError: p((r) => ({ type: "ERROR", error: r.error })),
      reportSuccess: p("SUCCESS")
    },
    guards: {
      invalidEmail: (r, { email: t }) => !I(t)
    },
    services: {
      requestChange: (r, { email: t, options: s }) => y(`${n}/user/password/reset`, {
        email: t,
        options: w(e, s)
      })
    }
  }
), We = ({ backendUrl: n, clientUrl: e }) => O(
  {
    schema: {
      context: {},
      events: {},
      services: {}
    },
    tsTypes: {},
    predictableActionArguments: !0,
    id: "sendVerificationEmail",
    initial: "idle",
    context: { error: null },
    states: {
      idle: {
        on: {
          REQUEST: [
            {
              cond: "invalidEmail",
              actions: "saveInvalidEmailError",
              target: ".error"
            },
            {
              target: "requesting"
            }
          ]
        },
        initial: "initial",
        states: {
          initial: {},
          success: {},
          error: {}
        }
      },
      requesting: {
        invoke: {
          src: "request",
          id: "request",
          onDone: { target: "idle.success", actions: "reportSuccess" },
          onError: { actions: ["saveRequestError", "reportError"], target: "idle.error" }
        }
      }
    }
  },
  {
    actions: {
      saveInvalidEmailError: E({ error: (r) => _ }),
      saveRequestError: E({
        // * Untyped action payload. See https://github.com/statelyai/xstate/issues/3037
        error: (r, { data: { error: t } }) => t
      }),
      reportError: p((r) => ({ type: "ERROR", error: r.error })),
      reportSuccess: p("SUCCESS")
    },
    guards: {
      invalidEmail: (r, { email: t }) => !I(t)
    },
    services: {
      request: async (r, { email: t, options: s }) => (await y(
        `${n}/user/email/send-verification-email`,
        { email: t, options: w(e, s) }
      )).data
    }
  }
);
class le {
  constructor({
    clientStorageType: e = "web",
    autoSignIn: r = !0,
    autoRefreshToken: t = !0,
    start: s = !0,
    backendUrl: i,
    clientUrl: u,
    devTools: m,
    ...d
  }) {
    var h;
    if (this._started = !1, this._subscriptionsQueue = /* @__PURE__ */ new Set(), this._subscriptions = /* @__PURE__ */ new Set(), this.backendUrl = i, this.clientUrl = u, this._machine = Le({
      ...d,
      backendUrl: i,
      clientUrl: u,
      clientStorageType: e,
      autoSignIn: r,
      autoRefreshToken: t
    }), s && this.start({ devTools: m }), typeof window != "undefined")
      try {
        this._channel = new BroadcastChannel("nhost"), r && ((h = this._channel) == null || h.addEventListener("message", (a) => {
          var l;
          const { type: o, payload: c } = a.data;
          if (o === "broadcast_token") {
            const f = (l = this.interpreter) == null ? void 0 : l.getSnapshot().context.refreshToken.value;
            this.interpreter && c.token && c.token !== f && this.interpreter.send("TRY_TOKEN", { token: c.token });
          }
        })), this._channel.addEventListener("message", (a) => {
          const { type: o } = a.data;
          o === "signout" && this.interpreter && this.interpreter.send("SIGNOUT");
        });
      } catch {
      }
  }
  start({
    devTools: e = !1,
    initialSession: r,
    interpreter: t
  } = {}) {
    var u, m;
    const s = {
      ...this.machine.context,
      accessToken: {
        ...this.machine.context.accessToken
      },
      refreshToken: {
        ...this.machine.context.refreshToken
      }
    };
    r && (s.user = r.user, s.refreshToken.value = (u = r.refreshToken) != null ? u : null, s.accessToken.value = (m = r.accessToken) != null ? m : null, s.accessToken.expiresAt = new Date(
      Date.now() + r.accessTokenExpiresIn * 1e3
    ));
    const i = this.machine.withContext(s);
    this._interpreter || (this._interpreter = t || b(i, { devTools: e })), (!this._started || typeof window == "undefined") && (this._interpreter.initialized && (this._interpreter.stop(), this._subscriptions.forEach((d) => d())), this._interpreter.start(i.initialState), this._subscriptionsQueue.forEach((d) => d(this))), this._started = !0;
  }
  get machine() {
    return this._machine;
  }
  get interpreter() {
    return this._interpreter;
  }
  get started() {
    return this._started;
  }
  subscribe(e) {
    if (this.started) {
      const r = e(this);
      return this._subscriptions.add(r), r;
    } else
      return this._subscriptionsQueue.add(e), () => {
        console.log(
          "onTokenChanged was added before the interpreter started. Cannot unsubscribe listener."
        );
      };
  }
}
class Ye extends le {
  constructor({
    ...e
  }) {
    super({
      ...e,
      autoSignIn: K() && e.autoSignIn,
      autoRefreshToken: K() && e.autoRefreshToken,
      clientStorageType: "cookie"
    });
  }
}
const hr = Ye, je = async ({ backendUrl: n, interpreter: e }, r) => {
  try {
    const { data: t } = await y(
      `${n}/user/webauthn/add`,
      {},
      e == null ? void 0 : e.getSnapshot().context.accessToken.value
    );
    let s;
    try {
      s = await oe(t);
    } catch (u) {
      throw new N(u);
    }
    const { data: i } = await y(
      `${n}/user/webauthn/verify`,
      { credential: s, nickname: r },
      e == null ? void 0 : e.getSnapshot().context.accessToken.value
    );
    return { key: i, isError: !1, error: null, isSuccess: !0 };
  } catch (t) {
    const { error: s } = t;
    return { isError: !0, error: s, isSuccess: !1 };
  }
}, qe = async (n, e, r) => new Promise((t) => {
  n.send("REQUEST", {
    email: e,
    options: r
  }), n.onTransition((s) => {
    s.matches({ idle: "error" }) ? t({ error: s.context.error, isError: !0, needsEmailVerification: !1 }) : s.matches({ idle: "success" }) && t({ error: null, isError: !1, needsEmailVerification: !0 });
  });
}), Fe = async (n, e, r) => new Promise((t) => {
  n.send("REQUEST", {
    password: e,
    ticket: r
  }), n.onTransition((s) => {
    s.matches({ idle: "error" }) ? t({ error: s.context.error, isError: !0, isSuccess: !1 }) : s.matches({ idle: "success" }) && t({ error: null, isError: !1, isSuccess: !0 });
  });
}), fr = (n) => new Promise((e) => {
  n.send("GENERATE"), n.onTransition((r) => {
    r.matches("generated") ? e({
      error: null,
      isError: !1,
      isGenerated: !0,
      qrCodeDataUrl: r.context.imageUrl || ""
    }) : r.matches({ idle: "error" }) && e({
      error: r.context.error || null,
      isError: !0,
      isGenerated: !1,
      qrCodeDataUrl: ""
    });
  });
}), mr = (n, e) => new Promise((r) => {
  n.send("ACTIVATE", {
    activeMfaType: "totp",
    code: e
  }), n.onTransition((t) => {
    t.matches({ generated: "activated" }) ? r({ error: null, isActivated: !0, isError: !1 }) : t.matches({ generated: { idle: "error" } }) && r({ error: t.context.error, isActivated: !1, isError: !0 });
  });
}), Be = async (n, e, r) => new Promise((t) => {
  n.send("REQUEST", {
    email: e,
    options: r
  }), n.onTransition((s) => {
    s.matches({ idle: "error" }) ? t({ error: s.context.error, isError: !0, isSent: !1 }) : s.matches({ idle: "success" }) && t({ error: null, isError: !1, isSent: !0 });
  });
}), ze = (n, e, r) => new Promise((t) => {
  n.send("REQUEST", {
    email: e,
    options: r
  }), n.onTransition((s) => {
    s.matches({ idle: "error" }) ? t({ error: s.context.error, isError: !0, isSent: !1 }) : s.matches({ idle: "success" }) && t({ error: null, isError: !1, isSent: !0 });
  });
}), Qe = (n) => new Promise((e) => {
  const { changed: r } = n.send("SIGNIN_ANONYMOUS");
  r || e({
    isSuccess: !1,
    isError: !0,
    error: R,
    user: null,
    accessToken: null,
    refreshToken: null
  }), n.onTransition((t) => {
    t.matches({ authentication: "signedIn" }) && e({
      isSuccess: !0,
      isError: !1,
      error: null,
      user: t.context.user,
      accessToken: t.context.accessToken.value,
      refreshToken: t.context.refreshToken.value
    }), t.matches({ authentication: { signedOut: "failed" } }) && e({
      isSuccess: !1,
      isError: !0,
      error: t.context.errors.authentication || null,
      user: null,
      accessToken: null,
      refreshToken: null
    });
  });
}), Xe = (n, e, r) => new Promise((t) => {
  const { changed: s, context: i } = n.send("SIGNIN_PASSWORD", {
    email: e,
    password: r
  });
  if (!s)
    return t({
      accessToken: i.accessToken.value,
      refreshToken: i.refreshToken.value,
      error: R,
      isError: !0,
      isSuccess: !1,
      needsEmailVerification: !1,
      needsMfaOtp: !1,
      mfa: null,
      user: i.user
    });
  n.onTransition((u) => {
    u.matches({
      authentication: { signedOut: "noErrors" },
      registration: { incomplete: "needsEmailVerification" }
    }) ? t({
      accessToken: null,
      refreshToken: null,
      error: null,
      isError: !1,
      isSuccess: !1,
      needsEmailVerification: !0,
      needsMfaOtp: !1,
      mfa: null,
      user: null
    }) : u.matches({ authentication: { signedOut: "needsMfa" } }) ? t({
      accessToken: null,
      refreshToken: null,
      error: null,
      isError: !1,
      isSuccess: !1,
      needsEmailVerification: !1,
      needsMfaOtp: !0,
      mfa: u.context.mfa,
      user: null
    }) : u.matches({ authentication: { signedOut: "failed" } }) ? t({
      accessToken: null,
      refreshToken: null,
      error: u.context.errors.authentication || null,
      isError: !0,
      isSuccess: !1,
      needsEmailVerification: !1,
      needsMfaOtp: !1,
      mfa: null,
      user: null
    }) : u.matches({ authentication: "signedIn" }) && t({
      accessToken: u.context.accessToken.value,
      refreshToken: u.context.refreshToken.value,
      error: null,
      isError: !1,
      isSuccess: !0,
      needsEmailVerification: !1,
      needsMfaOtp: !1,
      mfa: null,
      user: u.context.user
    });
  });
}), Q = (n, e, r) => new Promise((t) => {
  const { changed: s } = n.send("PASSWORDLESS_EMAIL", {
    email: e,
    options: r
  });
  if (!s)
    return t({
      error: R,
      isError: !0,
      isSuccess: !1
    });
  n.onTransition((i) => {
    i.matches("registration.incomplete.failed") ? t({
      error: i.context.errors.registration || null,
      isError: !0,
      isSuccess: !1
    }) : i.matches({
      authentication: { signedOut: "noErrors" },
      registration: { incomplete: "needsEmailVerification" }
    }) && t({ error: null, isError: !1, isSuccess: !0 });
  });
}), Ze = (n, e) => new Promise((r) => {
  const { changed: t, context: s } = n.send({ type: "SIGNIN_SECURITY_KEY_EMAIL", email: e });
  if (!t)
    return r({
      accessToken: s.accessToken.value,
      refreshToken: s.refreshToken.value,
      error: R,
      isError: !0,
      isSuccess: !1,
      needsEmailVerification: !1,
      user: s.user
    });
  n.onTransition((i) => {
    i.matches({
      authentication: { signedOut: "noErrors" },
      registration: { incomplete: "needsEmailVerification" }
    }) ? r({
      accessToken: null,
      refreshToken: null,
      error: null,
      isError: !1,
      isSuccess: !1,
      needsEmailVerification: !0,
      user: null
    }) : i.matches({ authentication: { signedOut: "failed" } }) ? r({
      accessToken: null,
      refreshToken: null,
      error: i.context.errors.authentication || null,
      isError: !0,
      isSuccess: !1,
      needsEmailVerification: !1,
      user: null
    }) : i.matches({ authentication: "signedIn" }) && r({
      accessToken: i.context.accessToken.value,
      refreshToken: i.context.refreshToken.value,
      error: null,
      isError: !1,
      isSuccess: !0,
      needsEmailVerification: !1,
      user: i.context.user
    });
  });
}), Je = (n, e) => new Promise(async (r) => {
  var m, d;
  const t = (m = n.interpreter) == null ? void 0 : m.getSnapshot(), s = t == null ? void 0 : t.context.accessToken.value, { data: i } = await y(
    `${n.backendUrl}/elevate/webauthn`,
    {
      email: e
    },
    s
  );
  let u;
  try {
    u = await ae(i);
  } catch (h) {
    throw new N(h);
  }
  try {
    const {
      data: { session: h },
      error: a
    } = await y(
      `${n.backendUrl}/elevate/webauthn/verify`,
      {
        email: e,
        credential: u
      },
      s
    );
    h && !a && ((d = n.interpreter) == null || d.send({
      type: "SESSION_UPDATE",
      data: {
        session: h
      }
    }), r({
      error: null,
      isError: !1,
      isSuccess: !0,
      elevated: !0
    }));
  } catch (h) {
    const { error: a } = h;
    r({
      error: a,
      isError: !0,
      isSuccess: !1,
      elevated: !1
    });
  }
}), er = (n, e, r) => new Promise((t) => {
  const { changed: s, context: i } = n.send("SIGNIN_MFA_TOTP", {
    otp: e,
    ticket: r
  });
  if (!s)
    return t({
      accessToken: i.accessToken.value,
      refreshToken: i.refreshToken.value,
      error: R,
      isError: !0,
      isSuccess: !1,
      user: i.user
    });
  n.onTransition((u) => {
    u.matches({ authentication: { signedOut: "failed" } }) ? t({
      accessToken: null,
      refreshToken: null,
      error: u.context.errors.authentication || null,
      isError: !0,
      isSuccess: !1,
      user: null
    }) : u.matches({ authentication: "signedIn" }) && t({
      accessToken: u.context.accessToken.value,
      refreshToken: u.context.refreshToken.value,
      error: null,
      isError: !1,
      isSuccess: !0,
      user: u.context.user
    });
  });
}), rr = (n, e) => new Promise((r) => {
  const { changed: t } = n.send("SIGNIN_PAT", { pat: e });
  t || r({
    isSuccess: !1,
    isError: !0,
    error: R,
    user: null,
    accessToken: null,
    refreshToken: null
  }), n.onTransition((s) => {
    if (s.matches({ authentication: { signedOut: "failed" } }))
      return r({
        accessToken: null,
        refreshToken: null,
        user: null,
        error: s.context.errors.authentication || null,
        isError: !0,
        isSuccess: !1
      });
    if (s.matches({ authentication: "signedIn" }))
      return r({
        accessToken: s.context.accessToken.value,
        refreshToken: s.context.refreshToken.value,
        user: s.context.user,
        error: null,
        isError: !1,
        isSuccess: !0
      });
  });
}), X = (n, e, r) => new Promise((t) => {
  const { changed: s } = n.send("PASSWORDLESS_SMS", { phoneNumber: e, options: r });
  if (!s)
    return t({
      error: R,
      isError: !0,
      isSuccess: !1,
      needsOtp: !1
    });
  n.onTransition((i) => {
    i.matches("registration.incomplete.needsOtp") ? t({
      error: null,
      isError: !1,
      isSuccess: !1,
      needsOtp: !0
    }) : i.matches("registration.incomplete.failed") && t({
      error: i.context.errors.authentication || null,
      isError: !0,
      isSuccess: !1,
      needsOtp: !1
    });
  });
}), tr = (n, e, r) => new Promise((t) => {
  const { changed: s } = n.send({ type: "PASSWORDLESS_SMS_OTP", phoneNumber: e, otp: r });
  if (!s)
    return t({
      error: R,
      isError: !0,
      isSuccess: !1,
      user: null,
      accessToken: null,
      refreshToken: null
    });
  n.onTransition((i) => {
    i.matches({ authentication: "signedIn" }) ? t({
      error: null,
      isError: !1,
      isSuccess: !0,
      user: i.context.user,
      accessToken: i.context.accessToken.value,
      refreshToken: i.context.refreshToken.value
    }) : i.matches({ registration: { incomplete: "failed" } }) && t({
      error: i.context.errors.authentication || null,
      isError: !0,
      isSuccess: !1,
      user: null,
      accessToken: null,
      refreshToken: null
    });
  });
}), nr = async (n, e) => new Promise((r) => {
  const { event: t } = n.send("SIGNOUT", { all: e });
  if (t.type !== "SIGNED_OUT")
    return r({ isSuccess: !1, isError: !0, error: Re });
  n.onTransition((s) => {
    s.matches({ authentication: { signedOut: "success" } }) ? r({ isSuccess: !0, isError: !1, error: null }) : s.matches("authentication.signedOut.failed") && r({ isSuccess: !1, isError: !0, error: s.context.errors.signout || null });
  });
}), Z = (n, e, r, t, s) => new Promise((i) => {
  const { changed: u, context: m } = n.send("SIGNUP_EMAIL_PASSWORD", {
    email: e,
    password: r,
    options: t,
    requestOptions: s
  });
  if (!u)
    return i({
      error: R,
      accessToken: m.accessToken.value,
      refreshToken: m.refreshToken.value,
      isError: !0,
      isSuccess: !1,
      needsEmailVerification: !1,
      user: m.user
    });
  n.onTransition((d) => {
    d.matches("registration.incomplete.failed") ? i({
      accessToken: null,
      refreshToken: null,
      error: d.context.errors.registration || null,
      isError: !0,
      isSuccess: !1,
      needsEmailVerification: !1,
      user: null
    }) : d.matches({
      authentication: { signedOut: "noErrors" },
      registration: { incomplete: "needsEmailVerification" }
    }) ? i({
      accessToken: null,
      refreshToken: null,
      error: null,
      isError: !1,
      isSuccess: !1,
      needsEmailVerification: !0,
      user: null
    }) : d.matches({ authentication: "signedIn", registration: "complete" }) && i({
      accessToken: d.context.accessToken.value,
      refreshToken: d.context.refreshToken.value,
      error: null,
      isError: !1,
      isSuccess: !0,
      needsEmailVerification: !1,
      user: d.context.user
    });
  });
}), sr = (n, e, r) => new Promise((t) => {
  const { changed: s, context: i } = n.send("SIGNUP_SECURITY_KEY", {
    email: e,
    options: r
  });
  if (!s)
    return t({
      error: R,
      accessToken: i.accessToken.value,
      refreshToken: i.refreshToken.value,
      isError: !0,
      isSuccess: !1,
      needsEmailVerification: !1,
      user: i.user
    });
  n.onTransition((u) => {
    u.matches("registration.incomplete.failed") ? t({
      accessToken: null,
      refreshToken: null,
      error: u.context.errors.registration || null,
      isError: !0,
      isSuccess: !1,
      needsEmailVerification: !1,
      user: null
    }) : u.matches({
      authentication: { signedOut: "noErrors" },
      registration: { incomplete: "needsEmailVerification" }
    }) ? t({
      accessToken: null,
      refreshToken: null,
      error: null,
      isError: !1,
      isSuccess: !1,
      needsEmailVerification: !0,
      user: null
    }) : u.matches({ authentication: "signedIn", registration: "complete" }) && t({
      accessToken: u.context.accessToken.value,
      refreshToken: u.context.refreshToken.value,
      error: null,
      isError: !1,
      isSuccess: !0,
      needsEmailVerification: !1,
      user: u.context.user
    });
  });
}), ir = async ({ backendUrl: n, interpreter: e }, { expiresAt: r, metadata: t }) => {
  try {
    const { data: s } = await y(
      `${n}/pat`,
      { expiresAt: r.toISOString(), metadata: t },
      e == null ? void 0 : e.getSnapshot().context.accessToken.value
    );
    return {
      data: s ? {
        id: s.id || null,
        personalAccessToken: s.personalAccessToken || null
      } : null,
      isError: !1,
      error: null,
      isSuccess: !0
    };
  } catch (s) {
    const { error: i } = s;
    return { isError: !0, error: i, isSuccess: !1, data: null };
  }
};
class Er {
  constructor({
    url: e,
    autoRefreshToken: r = !0,
    autoSignIn: t = !0,
    clientStorage: s,
    clientStorageType: i,
    refreshIntervalTime: u,
    start: m = !0
  }) {
    var d;
    this.url = e, this._client = new le({
      backendUrl: e,
      clientUrl: typeof window != "undefined" && ((d = window.location) == null ? void 0 : d.origin) || "",
      autoRefreshToken: r,
      autoSignIn: t,
      start: m,
      clientStorage: s,
      clientStorageType: i,
      refreshIntervalTime: u
    });
  }
  /**
   * Use `nhost.auth.signUp` to sign up a user using email and password. If you want to sign up a user using passwordless email (Magic Link), SMS, or an OAuth provider, use the `signIn` function instead.
   *
   * @example
   * ### Sign up with an email and password
   * ```ts
   * nhost.auth.signUp({
   *   email: 'joe@example.com',
   *   password: 'secret-password'
   * })
   * ```
   *
   * @example
   * ### Sign up with a security key
   * ```ts
   * nhost.auth.signUp({
   *   email: 'joe@example.com',
   *   securityKey: true
   * })
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/sign-up
   */
  async signUp(e) {
    const r = await this.waitUntilReady(), { email: t, options: s } = e;
    return "securityKey" in e ? S(
      await sr(r, t, s)
    ) : S(
      await Z(r, t, e.password, s)
    );
  }
  /**
   * Use `nhost.auth.connectProvider` to connect a social authentication provider to an existing user account
   *
   * @example
   * ### Connect an authentication provider to an existing user account
   * ```ts
   * nhost.auth.connectProvider({
   *   provider: 'github
   *   options: {
   *    redirectTo: window.location.href
   *   }
   * })
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/connect-provider
   */
  async connectProvider(e) {
    const t = (await this.waitUntilReady()).getSnapshot().context.accessToken.value, { provider: s, options: i } = e, u = W(
      `${this._client.backendUrl}/signin/provider/${s}`,
      w(this._client.clientUrl, {
        ...i,
        connect: t
      })
    );
    return K() && (window.location.href = u), { providerUrl: u };
  }
  /**
   * Use `nhost.auth.signIn` to sign in a user using email and password, passwordless (email or sms) or an external provider. `signIn` can be used to sign in a user in various ways depending on the parameters.
   *
   * @example
   * ### Sign in a user using email and password
   * ```ts
   * nhost.auth.signIn({
   *   email: 'joe@example.com',
   *   password: 'secret-password'
   * })
   * ```
   *
   * @example
   * ### Sign in a user using an OAuth provider (e.g: Google or Facebook)
   * ```ts
   * nhost.auth.signIn({ provider: 'google' })
   * ```
   *
   * @example
   * ### Sign in a user using passwordless email (Magic Link)
   * ```ts
   * nhost.auth.signIn({ email: 'joe@example.com' })
   * ```
   *
   * @example
   * ### Sign in a user using passwordless SMS
   * ```ts
   * // [step 1/2] Passwordless sign in using SMS
   * nhost.auth.signIn({ phoneNumber: '+11233213123' })
   *
   * // [step 2/2] Finish passwordless sign in using SMS (OTP)
   * nhost.auth.signIn({ phoneNumber: '+11233213123', otp: '123456' })
   * ```
   *
   * @example
   * ### Sign in anonymously
   * ```ts
   * // Sign in anonymously
   * nhost.auth.signIn()
   *
   * // Later in the application, the user can complete their registration
   * nhost.auth.signUp({
   *   email: 'joe@example.com',
   *   password: 'secret-password'
   * })
   * ```
   *
   * @example
   * ### Sign in with a security key
   * ```ts
   * nhost.auth.signIn({
   *   email: 'joe@example.com',
   *   securityKey: true
   * })
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/sign-in
   */
  async signIn(e) {
    const r = await this.waitUntilReady();
    if (!e) {
      const t = await Qe(r);
      return { ...S(t), mfa: null };
    }
    if ("provider" in e) {
      const { provider: t, options: s } = e, i = W(
        `${this._client.backendUrl}/signin/provider/${t}`,
        w(this._client.clientUrl, s)
      );
      return K() && (window.location.href = i), { providerUrl: i, provider: t, session: null, mfa: null, error: null };
    }
    if ("email" in e && "password" in e) {
      const t = await Xe(r, e.email, e.password);
      return t.needsEmailVerification ? { session: null, mfa: null, error: Ae } : t.needsMfaOtp ? {
        session: null,
        mfa: t.mfa,
        error: null
      } : { ...S(t), mfa: null };
    }
    if ("email" in e && "securityKey" in e) {
      if (e.securityKey !== !0)
        throw Error("securityKey must be true");
      const t = await Ze(r, e.email);
      return { ...S(t), mfa: null };
    }
    if ("email" in e) {
      const { email: t, options: s } = e, { error: i } = await Q(r, t, s);
      return {
        session: null,
        mfa: null,
        error: i
      };
    }
    if ("phoneNumber" in e && "otp" in e) {
      const t = await tr(r, e.phoneNumber, e.otp);
      return { ...S(t), mfa: null };
    }
    if ("phoneNumber" in e) {
      const { error: t } = await X(
        r,
        e.phoneNumber,
        e.options
      );
      return { error: t, mfa: null, session: null };
    }
    if ("otp" in e) {
      const t = await er(r, e.otp, e.ticket);
      return { ...S(t), mfa: null };
    }
    return { error: _e, mfa: null, session: null };
  }
  /**
   * Use `nhost.auth.signInPAT` to sign in with a personal access token (PAT).
   *
   * @example
   * ```ts
   * nhost.auth.signInPAT('34f74930-09c0-4af5-a8d5-28fad78e3415')
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/sign-in-pat
   *
   * @param personalAccessToken - The personal access token to sign in with
   */
  async signInPAT(e) {
    const r = await this.waitUntilReady(), t = await rr(r, e);
    return S(t);
  }
  /**
   * Use `nhost.auth.signOut` to sign out the user.
   *
   * @example
   * ### Sign out the user from current device
   * ```ts
   * nhost.auth.signOut()
   * ```
   *
   * @example
   * ### Sign out the user from all devices
   * ```ts
   * nhost.auth.signOut({all: true})
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/sign-out
   */
  async signOut(e) {
    const r = await this.waitUntilReady(), { error: t } = await nr(r, e == null ? void 0 : e.all);
    return { error: t };
  }
  /**
   * Use `nhost.auth.resetPassword` to reset the password for a user. This will send a reset-password link in an email to the user. When the user clicks the reset-password link the user is automatically signed-in. Once signed-in, the user can change their password using `nhost.auth.changePassword()`.
   *
   * @example
   * ```ts
   * nhost.auth.resetPassword({email: 'joe@example.com' })
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/reset-password
   */
  async resetPassword({ email: e, options: r }) {
    const t = b(He(this._client)).start(), { error: s } = await Be(t, e, r);
    return { error: s };
  }
  /**
   * Use `nhost.auth.changePassword` to change the password for the signed-in user. The old password is not needed. In case the user is not signed-in, a password reset ticket needs to be provided.
   *
   * @example
   * ```ts
   * nhost.auth.changePassword({ newPassword: 'new-secret-password' })
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/change-password
   */
  async changePassword({
    newPassword: e,
    ticket: r
  }) {
    const t = b($e(this._client)).start(), { error: s } = await Fe(t, e, r);
    return { error: s };
  }
  /**
   * Use `nhost.auth.sendVerificationEmail` to send a verification email to the specified email. The email contains a verification-email link. When the user clicks the verification-email link their email is verified.
   *
   * @example
   * ```ts
   * nhost.auth.sendVerificationEmail({ email: 'joe@example.com' })
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/send-verification-email
   */
  async sendVerificationEmail({
    email: e,
    options: r
  }) {
    const t = b(We(this._client)).start(), { error: s } = await ze(t, e, r);
    return { error: s };
  }
  /**
   * Use `nhost.auth.changeEmail` to change a user's email. This will send a confirm-email-change link in an email to the new email. Once the user clicks on the confirm-email-change link the email will be change to the new email.
   *
   * @example
   * ```ts
   * nhost.auth.changeEmail({ newEmail: 'doe@example.com' })
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/change-email
   */
  async changeEmail({ newEmail: e, options: r }) {
    const t = b(Ge(this._client)).start(), { error: s } = await qe(t, e, r);
    return { error: s };
  }
  /**
   * Use `nhost.auth.deanonymize` to deanonymize a user.
   *
   * @example
   * ```ts
   * nhost.auth.deanonymize({signInMethod: 'email-password', email: 'joe@example.com' })
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/deanonymize
   */
  async deanonymize(e) {
    const r = await this.waitUntilReady();
    if (e.signInMethod === "passwordless") {
      if (e.connection === "email") {
        const { error: t } = await Q(
          r,
          e.email,
          e.options
        );
        return { error: t };
      }
      if (e.connection === "sms") {
        const { error: t } = await X(
          r,
          e.phoneNumber,
          e.options
        );
        return { error: t };
      }
    }
    if (e.signInMethod === "email-password") {
      const { error: t } = await Z(
        r,
        e.email,
        e.password,
        e.options
      );
      return { error: t };
    }
    throw Error("Unknown deanonymization method");
  }
  /**
   * Use `nhost.auth.addSecurityKey` to add a security key to the user, using the WebAuthn API.
   * @param nickname optional human-readable nickname for the security key
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/add-security-key
   */
  async addSecurityKey(e) {
    const { error: r, key: t } = await je(this._client, e);
    return { error: r, key: t };
  }
  /**
   * Use `nhost.auth.elevateEmailSecurityKey` to get a temporary elevated auth permissions to run sensitive operations.
   * @param email user email
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/elevate-email-security-key
   */
  async elevateEmailSecurityKey(e) {
    if (!e)
      throw Error("A user email is required");
    return { ...await Je(this._client, e), mfa: null };
  }
  /**
   * Use `nhost.auth.createPAT` to create a personal access token for the user.
   *
   * @param expiresAt Expiration date for the token
   * @param metadata Optional metadata to store with the token
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/create-pat
   */
  async createPAT(e, r) {
    return ir(this._client, { expiresAt: e, metadata: r });
  }
  /**
   * Use `nhost.auth.onTokenChanged` to add a custom function that runs every time the access or refresh token is changed.
   *
   *
   * @example
   * ```ts
   * nhost.auth.onTokenChanged(() => console.log('The access and refresh token has changed'));
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/on-token-changed
   */
  onTokenChanged(e) {
    return this._client.subscribe(() => {
      var t;
      const r = (t = this._client.interpreter) == null ? void 0 : t.onTransition(({ event: s, context: i }) => {
        s.type === "TOKEN_CHANGED" && e(x(i));
      });
      return () => r == null ? void 0 : r.stop();
    });
  }
  /**
   * Use `nhost.auth.onAuthStateChanged` to add a custom function that runs every time the authentication status of the user changes. E.g. add a custom function that runs every time the authentication status changes from signed-in to signed-out.
   *
   * @example
   * ```ts
   * nhost.auth.onAuthStateChanged((event, session) => {
   *   console.log(`The auth state has changed. State is now ${event} with session: ${session}`)
   * });
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/on-auth-state-changed
   */
  onAuthStateChanged(e) {
    return this._client.subscribe(() => {
      var t;
      const r = (t = this._client.interpreter) == null ? void 0 : t.onTransition(({ event: s, context: i }) => {
        (s.type === "SIGNED_IN" || s.type === "SIGNED_OUT") && e(s.type, x(i));
      });
      return () => r == null ? void 0 : r.stop();
    });
  }
  /**
   * Use `nhost.auth.isAuthenticated` to check if the user is authenticated or not.
   *
   * Note: `nhost.auth.isAuthenticated()` can return `false` for two reasons:
   * 1. The user is not authenticated
   * 2. The user is not authenticated but _might_ be authenticated soon (loading) because there is a network request in transit.
   *
   * Use `nhost.auth.getAuthenticationStatus` to get both authentication and loading status.
   *
   * @example
   * ```ts
   * const isAuthenticated = nhost.auth.isAuthenticated();
   *
   * if (isAuthenticated) {
   *   console.log('User is authenticated');
   * }
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/is-authenticated
   */
  isAuthenticated() {
    var e;
    return !!((e = this._client.interpreter) != null && e.getSnapshot().matches({ authentication: "signedIn" }));
  }
  /**
   * Use `nhost.auth.isAuthenticatedAsync` to wait (await) for any internal authentication network requests to finish and then return the authentication status.
   *
   * The promise won't resolve until the authentication status is known.
   * Attention: when using auto-signin and a refresh token is present in the client storage, the promise won't resolve if the server can't be reached (e.g. offline) or if it returns an internal error.
   *
   * @example
   * ```ts
   * const isAuthenticated  = await nhost.auth.isAuthenticatedAsync();
   *
   * if (isAuthenticated) {
   *   console.log('User is authenticated');
   * }
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/is-authenticated-async
   */
  async isAuthenticatedAsync() {
    return (await this.waitUntilReady()).getSnapshot().matches({ authentication: "signedIn" });
  }
  /**
   * Use `nhost.auth.getAuthenticationStatus` to get the authentication status of the user.
   *
   * If `isLoading` is `true`, the client doesn't know whether the user is authenticated yet or not
   * because some internal authentication network requests have not been resolved yet.
   *
   * The `connectionAttempts` returns the number of times the client has tried to connect to the server with no success (offline, or the server retruned an internal error).
   *
   * @example
   * ```ts
   * const { isAuthenticated, isLoading } = nhost.auth.getAuthenticationStatus();
   *
   * if (isLoading) {
   *   console.log('Loading...')
   * }
   *
   * if (isAuthenticated) {
   *   console.log('User is authenticated');
   * }
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/get-authentication-status
   */
  getAuthenticationStatus() {
    var r;
    const e = ((r = this.client.interpreter) == null ? void 0 : r.getSnapshot().context.importTokenAttempts) || 0;
    return this.isReady() ? { isAuthenticated: this.isAuthenticated(), isLoading: !1, connectionAttempts: e } : {
      isAuthenticated: !1,
      isLoading: !0,
      connectionAttempts: e
    };
  }
  /**
   * Use `nhost.auth.getAccessToken` to get the access token of the user.
   *
   * @example
   * ```ts
   * const accessToken = nhost.auth.getAccessToken();
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/get-access-token
   */
  getAccessToken() {
    var e, r;
    return (r = (e = this._client.interpreter) == null ? void 0 : e.getSnapshot().context.accessToken.value) != null ? r : void 0;
  }
  /**
   * Use `nhost.auth.getDecodedAccessToken` to get the decoded access token of the user.
   *
   * @example
   * ```ts
   * const decodedAccessToken = nhost.auth.getDecodedAccessToken();
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/get-decoded-access-token
   */
  getDecodedAccessToken() {
    const e = this.getAccessToken();
    return e ? he(e) : null;
  }
  /**
   * Use `nhost.auth.getHasuraClaims` to get the Hasura claims of the user.
   *
   * @example
   * ```ts
   * const hasuraClaims = nhost.auth.getHasuraClaims();
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/get-hasura-claims
   */
  getHasuraClaims() {
    var e;
    return ((e = this.getDecodedAccessToken()) == null ? void 0 : e["https://hasura.io/jwt/claims"]) || null;
  }
  /**
   * Use `nhost.auth.getHasuraClaim` to get the value of a specific Hasura claim of the user.
   *
   * @example
   * ```ts
   * // if `x-hasura-company-id` exists as a custom claim
   * const companyId = nhost.auth.getHasuraClaim('company-id')
   * ```
   *
   * @param name Name of the variable. You don't have to specify `x-hasura-`.
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/get-hasura-claim
   */
  getHasuraClaim(e) {
    var r;
    return ((r = this.getHasuraClaims()) == null ? void 0 : r[e.startsWith("x-hasura-") ? e : `x-hasura-${e}`]) || null;
  }
  /**
   *
   * Use `nhost.auth.refreshSession` to refresh the session with either the current internal refresh token or an external refresh token.
   *
   * Note: The Nhost client automatically refreshes the session when the user is authenticated but `nhost.auth.refreshSession` can be useful in some special cases.
   *
   * @example
   * ```ts
   * // Refresh the session with the the current internal refresh token.
   * nhost.auth.refreshToken();
   *
   * // Refresh the session with an external refresh token.
   * nhost.auth.refreshToken(refreshToken);
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/refresh-session
   */
  async refreshSession(e) {
    try {
      const r = await this.waitUntilReady();
      return new Promise((t) => {
        const s = e || r.getSnapshot().context.refreshToken.value;
        if (!s)
          return t({ session: null, error: ye });
        const { changed: i } = r.send("TRY_TOKEN", { token: s });
        if (!i)
          return t({ session: null, error: ke });
        r.onTransition((u) => {
          u.matches({ token: { idle: "error" } }) ? t({
            session: null,
            // * TODO get the error from xstate once it is implemented
            error: Se
          }) : u.event.type === "TOKEN_CHANGED" && t({ session: x(u.context), error: null });
        });
      });
    } catch (r) {
      return { session: null, error: r.message };
    }
  }
  /**
   *
   * Use `nhost.auth.getSession()` to get the session of the user.
   *
   * @example
   * ```ts
   * const session = nhost.auth.getSession();
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/get-session
   */
  getSession() {
    var e, r;
    return x((r = (e = this._client.interpreter) == null ? void 0 : e.getSnapshot()) == null ? void 0 : r.context);
  }
  /**
   *
   * Use `nhost.auth.getUser()` to get the signed-in user.
   *
   * @example
   * ```ts
   * const user = nhost.auth.getUser();
   * ```
   *
   * @docs https://docs.nhost.io/reference/javascript/auth/get-user
   */
  getUser() {
    var e, r, t;
    return ((t = (r = (e = this._client.interpreter) == null ? void 0 : e.getSnapshot()) == null ? void 0 : r.context) == null ? void 0 : t.user) || null;
  }
  /**
   * Make sure the state machine is set, and wait for it to be ready
   * @returns
   */
  waitUntilReady() {
    const r = this._client.interpreter;
    if (!r)
      throw Error("Auth interpreter not set");
    return r.getSnapshot().hasTag("loading") ? new Promise((t, s) => {
      let i = setTimeout(
        () => s("The state machine is not yet ready after 15 seconds."),
        15e3
      );
      r.onTransition((u) => {
        if (!u.hasTag("loading"))
          return clearTimeout(i), t(r);
      });
    }) : Promise.resolve(r);
  }
  isReady() {
    var e, r;
    return !((r = (e = this._client.interpreter) == null ? void 0 : e.getSnapshot()) != null && r.hasTag("loading"));
  }
  get client() {
    return this._client;
  }
}
export {
  le as AuthClient,
  hr as AuthClientSSR,
  Ye as AuthCookieClient,
  N as CodifiedError,
  Ae as EMAIL_NEEDS_VERIFICATION,
  Er as HasuraAuthClient,
  L as INITIAL_MACHINE_CONTEXT,
  _ as INVALID_EMAIL_ERROR,
  Te as INVALID_MFA_CODE_ERROR,
  pe as INVALID_MFA_TICKET_ERROR,
  ge as INVALID_MFA_TYPE_ERROR,
  H as INVALID_PASSWORD_ERROR,
  F as INVALID_PHONE_NUMBER_ERROR,
  Se as INVALID_REFRESH_TOKEN,
  _e as INVALID_SIGN_IN_METHOD,
  me as MIN_PASSWORD_LENGTH,
  J as NETWORK_ERROR_CODE,
  v as NHOST_JWT_EXPIRES_AT_KEY,
  D as NHOST_REFRESH_TOKEN_ID_KEY,
  P as NHOST_REFRESH_TOKEN_KEY,
  we as NO_MFA_TICKET_ERROR,
  ye as NO_REFRESH_TOKEN,
  ee as OTHER_ERROR_CODE,
  q as REFRESH_TOKEN_MAX_ATTEMPTS,
  C as STATE_ERROR_CODE,
  ke as TOKEN_REFRESHER_RUNNING_ERROR,
  Ee as TOKEN_REFRESH_MARGIN_SECONDS,
  R as USER_ALREADY_SIGNED_IN,
  lr as USER_NOT_ANONYMOUS,
  Re as USER_UNAUTHENTICATED,
  k as VALIDATION_ERROR_CODE,
  mr as activateMfaPromise,
  je as addSecurityKeyPromise,
  qe as changeEmailPromise,
  Fe as changePasswordPromise,
  Le as createAuthMachine,
  Ge as createChangeEmailMachine,
  $e as createChangePasswordMachine,
  dr as createEnableMfaMachine,
  He as createResetPasswordMachine,
  We as createSendVerificationEmailMachine,
  Je as elevateEmailSecurityKeyPromise,
  W as encodeQueryParameters,
  fr as generateQrCodePromise,
  S as getAuthenticationResult,
  Ke as getFetch,
  U as getParameterByName,
  x as getSession,
  K as isBrowser,
  I as isValidEmail,
  Y as isValidPassword,
  z as isValidPhoneNumber,
  Ve as isValidTicket,
  Ue as localStorageGetter,
  Me as localStorageSetter,
  y as postFetch,
  B as removeParameterFromWindow,
  Be as resetPasswordPromise,
  w as rewriteRedirectTo,
  ze as sendVerificationEmailPromise,
  Qe as signInAnonymousPromise,
  Xe as signInEmailPasswordPromise,
  Q as signInEmailPasswordlessPromise,
  Ze as signInEmailSecurityKeyPromise,
  er as signInMfaTotpPromise,
  rr as signInPATPromise,
  tr as signInSmsPasswordlessOtpPromise,
  X as signInSmsPasswordlessPromise,
  nr as signOutPromise,
  Z as signUpEmailPasswordPromise,
  sr as signUpEmailSecurityKeyPromise
};
//# sourceMappingURL=index.esm.js.map
